import { OK } from 'http-status-codes'

const getStandartOutput = () => ({
  error: true,
  message: null,
  data: [] })

// Funcion que puede ser usada en los .then de las llamadas al axios
export function lrsSuccessAdapter (response) {
  const { status, data } = response
  const ret = getStandartOutput()

  if (status !== OK) return ret

  const { estado, filas, error, claims = undefined } = data

  if (estado === 'error') {
    if (error['mensaje']) {
      ret.message = error['descripcion'] || error['mensaje']
    }
    return ret
  } else {
    ret.error = false
  }

  ret.data = filas || (claims ? [claims] : ret.data)
  return ret
}

// Funcion para ser usada en los .catch de llamadas del axios
export function lrsErrorAdapter (error) {
  const { response } = error
  console.log('LRS error destructurado', response)
  const { data: { error: dataError }, status, statusText } = response

  const ret = getStandartOutput()
  ret.message = dataError['descripcion'] || `${status} - ${statusText}: ${dataError['mensaje']}`
  return ret
}

export const lrsAdapter = (axiosResponse) => {
  if (axiosResponse['status'] !== undefined &&
    axiosResponse['response'] === undefined) { return lrsSuccessAdapter(axiosResponse) }
  return lrsErrorAdapter(axiosResponse)
}

export default lrsAdapter
